export default [
  {
    image: { src: 'https://satyr.dev/1120x1280/1', alt: 'Primary title' },
    primaryTitle: 'Primary title',
    secondaryTitle: 'Secondary title',
    href: 'https://www.christies.com/',
    cta: {
      href: 'https://www.christies.com/',
      text: 'View lot',
    },
  },
  {
    image: { src: 'https://satyr.dev/1120x1280/2', alt: 'Primary title' },
    primaryTitle: 'Primary title',
    secondaryTitle: 'Secondary title',
    href: 'https://www.christies.com/',
    cta: {
      href: 'https://www.christies.com/',
      text: 'View lot',
    },
  },
  {
    image: { src: 'https://satyr.dev/1120x1280/3', alt: 'Primary title' },
    primaryTitle: 'Primary title',
    secondaryTitle: 'Secondary title',
    href: 'https://www.christies.com/',
    cta: {
      href: 'https://www.christies.com/',
      text: 'View lot',
    },
  },
  {
    image: { src: 'https://satyr.dev/1120x1280/4', alt: 'Primary title' },
    primaryTitle: 'Primary title',
    secondaryTitle: 'Secondary title',
    href: 'https://www.christies.com/',
    cta: {
      href: 'https://www.christies.com/',
      text: 'View lot',
    },
  },
  {
    image: { src: 'https://satyr.dev/1120x1280/5', alt: 'Primary title' },
    primaryTitle: 'Primary title',
    secondaryTitle: 'Secondary title',
    href: 'https://www.christies.com/',
    cta: {
      href: 'https://www.christies.com/',
      text: 'View lot',
    },
  },
  {
    image: { src: 'https://satyr.dev/1120x1280/6', alt: 'Primary title' },
    primaryTitle: 'Primary title',
    secondaryTitle: 'Secondary title',
    href: 'https://www.christies.com/',
    cta: {
      href: 'https://www.christies.com/',
      text: 'View lot',
    },
  },
]
